import { USER_SERVICE } from 'api/constants';
import { createGetEndpoint } from 'api/utils';
import { CREATE_USER_PROFILE_PATH, SOCIAL_AUTH_PATH } from './constants';

const PATHS_BY_NAME = {
  createProfile: CREATE_USER_PROFILE_PATH,
  socialAuth: SOCIAL_AUTH_PATH,
};

export const getUserEndpoint = createGetEndpoint(USER_SERVICE, PATHS_BY_NAME);
